import { isDayIso } from '@/shared/schedule/day'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export interface TaskSearch {
  day?: string
  taskId?: string
  patientId?: string
  scheduleEventId?: string
  create?: true
}

export function validateTaskSearch(search: Record<string, unknown>): TaskSearch {
  const result: TaskSearch = {}
  if (typeof search['day'] === 'string' && isDayIso(search['day'])) result.day = search['day']
  if (typeof search['taskId'] === 'string' && UUID.test(search['taskId'])) result.taskId = search['taskId']
  if (typeof search['patientId'] === 'string' && UUID.test(search['patientId'])) result.patientId = search['patientId']
  if (typeof search['scheduleEventId'] === 'string' && UUID.test(search['scheduleEventId']))
    result.scheduleEventId = search['scheduleEventId']
  if (search['create'] === true || search['create'] === 'true') result.create = true
  return result
}
